import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "pdf-toolbar" }
const _hoisted_2 = { id: "zoom-tool" }
const _hoisted_3 = { id: "page-tool" }
const _hoisted_4 = { id: "misc-tools" }
const _hoisted_5 = {
  key: 1,
  id: "search-field"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf_pagination_button = _resolveComponent("pdf-pagination-button")!
  const _component_pdf_button = _resolveComponent("pdf-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_pdf_pagination_button, {
        ref: "zoominator",
        "left-icon": "remove",
        "right-icon": "add",
        "left-tooltip": _ctx.toolTipZoomOut,
        "right-tooltip": _ctx.toolTipZoomIn,
        onLeftMethod: _ctx.zoomOut,
        onRightMethod: _ctx.zoomIn,
        "onUpdate:changePrimaryContent": _ctx.updateZoom,
        inputType: "number",
        primaryContent: (_ctx.currentPdfScale * 100).toFixed(0),
        secondaryContent: ' %'
      }, null, 8 /* PROPS */, ["left-tooltip", "right-tooltip", "onLeftMethod", "onRightMethod", "onUpdate:changePrimaryContent", "primaryContent"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_pdf_pagination_button, {
        ref: "paginator",
        "left-icon": "arrow_back_ios_new",
        "right-icon": "arrow_forward_ios",
        "left-tooltip": _ctx.toolTipPreviousPage,
        "right-tooltip": _ctx.toolTipNextPage,
        onLeftMethod: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('prevPage'))),
        onRightMethod: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('nextPage'))),
        "onUpdate:changePrimaryContent": _ctx.updatePage,
        inputType: "number",
        primaryContent: _ctx.currentPdfPage,
        secondaryContent: '/ ' + _ctx.totalNumberOfPdfPages
      }, null, 8 /* PROPS */, ["left-tooltip", "right-tooltip", "onUpdate:changePrimaryContent", "primaryContent", "secondaryContent"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.isSearchActive)
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            id: "search-bar",
            class: "search-bar",
            ref: "search",
            type: "text",
            onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('search', $event.target.value))),
            onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.$emit('search', $event.target.value)), ["enter"]))
          }, null, 544 /* NEED_HYDRATION, NEED_PATCH */))
        : _createCommentVNode("v-if", true),
      (_ctx.isSearchActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("input", {
              id: "small-size-search-bar",
              class: "search-bar",
              ref: "search",
              type: "text",
              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('search', $event.target.value))),
              onKeydown: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.$emit('search', $event.target.value)), ["enter"]))
            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
            _createVNode(_component_pdf_button, {
              singleIcon: "arrow_back_ios_new",
              onSingleMethod: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('searchReverse', _ctx.$refs.search.value)))
            }),
            _createVNode(_component_pdf_button, {
              singleIcon: "arrow_forward_ios",
              onSingleMethod: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('search', _ctx.$refs.search.value)))
            })
          ]))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_pdf_button, {
        id: "search-tool",
        class: "misc-button",
        tooltip: _ctx.isSearchActive ? _ctx.toolTipCloseSearch : _ctx.toolTipOpenSearch,
        "single-icon": _ctx.isSearchActive ? 'close' : 'search',
        onSingleMethod: _ctx.toggleSearch
      }, null, 8 /* PROPS */, ["tooltip", "single-icon", "onSingleMethod"]),
      _createVNode(_component_pdf_button, {
        class: "misc-button",
        tooltip: _ctx.toolTipPrint,
        "single-icon": "print",
        onSingleMethod: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('print')))
      }, null, 8 /* PROPS */, ["tooltip"]),
      _createVNode(_component_pdf_button, {
        class: "misc-button",
        tooltip: _ctx.toolTipDownload,
        "single-icon": "download",
        onSingleMethod: _cache[9] || (_cache[9] = ($event: any) => (_ctx.downloadPdf()))
      }, null, 8 /* PROPS */, ["tooltip"]),
      _createVNode(_component_pdf_button, {
        class: "tooltip",
        tooltip: _ctx.toolTipFullscreen,
        "single-icon": _ctx.isPdfFullscreen ? 'close_fullscreen' : 'open_in_full',
        onSingleMethod: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('expand')))
      }, null, 8 /* PROPS */, ["tooltip", "single-icon"])
    ])
  ]))
}